"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _PromotionBanner = _interopRequireDefault(require("./PromotionBanner"));

var _LocalStorageKeys = require("../../constants/LocalStorageKeys");

var _MarketingContactsSelectors = require("../../selectors/MarketingContactsSelectors");

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _HubMap = _interopRequireDefault(require("self-service-api/constants/HubMap"));

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

var _getUsageTracker = _interopRequireDefault(require("../../utils/getUsageTracker"));

var _ProductOwnershipSelectors = require("../../selectors/ProductOwnershipSelectors");

var _colors = require("HubStyleTokens/colors");

var _urls = require("pricing-pages-unified-ui/utils/urls");

var _MerchandiseSelectors = require("pricing-pages-unified-ui/selectors/MerchandiseSelectors");

var onClick = function onClick() {
  return (0, _getUsageTracker.default)().track('externalLinkClick', {
    name: 'mc-banner'
  });
};

var BodyText = function BodyText(_ref) {
  var isCustomer = _ref.isCustomer;
  var stringKey = isCustomer ? 'marketingContactsBeta.banner.existingUser.bodyLearnMore_jsx' : 'marketingContactsBeta.banner.newUser.bodyLearnMore_jsx';
  return _react.default.createElement(_FormattedJSXMessage.default, {
    message: stringKey,
    elements: {
      Link: (0, _styledComponents.default)(_UILink.default).withConfig({
        displayName: "MarketingContactsBetaBanner__Link",
        componentId: "zkhbs1-0"
      })(["white-space:nowrap;color:", " !important;text-decoration:underline !important;"], _colors.OBSIDIAN)
    },
    options: {
      external: true,
      href: _urls.MC_LANDING_PAGE_URL,
      onClick: onClick
    }
  });
};

var MarketingContactsBetaBanner = function MarketingContactsBetaBanner() {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isClosed = _useState2[0],
      setIsClosed = _useState2[1];

  var isInMCBeta = (0, _reactRedux.useSelector)(_MarketingContactsSelectors.isInMCBetaSelector);
  var highestOwnedMarketingMerchId = (0, _reactRedux.useSelector)(function (state) {
    return (0, _ProductOwnershipSelectors.highestOwnedMerchIdInHubSelector)(state, _Hubs.default.HUB_MARKETING);
  });
  var ownsAnyMCMerch = (0, _reactRedux.useSelector)(function (state) {
    return (0, _MerchandiseSelectors.isMarketingContactsSKUSelector)(state, highestOwnedMarketingMerchId);
  });
  (0, _react.useEffect)(function () {
    // Existing MC users will see the banner on load, but it'll go away once product ownership data comes in
    // We set localStorage here so that happens once, then subsequent page visits will never flash the banner
    if (ownsAnyMCMerch) localStorage.setItem(_LocalStorageKeys.MC_BANNER_CLOSED, 'true');
  }, [ownsAnyMCMerch]);
  var shouldShow = isInMCBeta && !isClosed && !ownsAnyMCMerch && localStorage.getItem(_LocalStorageKeys.MC_BANNER_CLOSED) !== 'true';

  var onCloseClick = function onCloseClick() {
    localStorage.setItem(_LocalStorageKeys.MC_BANNER_CLOSED, 'true');
    setIsClosed(true);
  };

  var ownsMarketingProduct = highestOwnedMarketingMerchId && highestOwnedMarketingMerchId !== _HubMap.default[_Hubs.default.HUB_MARKETING].highlightedFreeMerch;
  return _react.default.createElement(_PromotionBanner.default, {
    className: "m-bottom-4",
    shouldShow: shouldShow,
    closeable: true,
    onClose: onCloseClick,
    promotion: "MC beta",
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "marketingContactsBeta.banner.title"
    }),
    description: _react.default.createElement(BodyText, {
      isCustomer: ownsMarketingProduct
    })
  });
};

var _default = MarketingContactsBetaBanner;
exports.default = _default;
module.exports = exports.default;